import moment from 'moment';
import {isEventProgramFilterActive, relationMatchesSelection} from './eventListFilters';


/** Project news is related-project based; a leftover `?program=_id` empties the News list. */
export function getLatestNewsViewAllHref({program, relatedProject} = {}) {
  if(relatedProject) return '/news';
  const programId = program && (program.documentId || program.id);
  if(programId) return `/news?program=${programId}`;
  return '/news';
}


export function programCatalogIds(program) {
  if(!program) return [];
  return [program.documentId, program.id, program._id]
    .filter(value => value != null && value !== '')
    .map(String);
}

/** Map a `?program=` value to the catalog checkbox id, or null if it is unknown. */
export function resolveCatalogProgramId(programFromUrl, programs = []) {
  if(programFromUrl == null || programFromUrl === '' || programFromUrl === 'undefined'){
    return null;
  }
  const needle = String(programFromUrl);
  const match = programs.find(program => programCatalogIds(program).includes(needle));
  return match ? match.id : null;
}

/** Same as Events: all programs checked, unless `?program=` matches the catalog. Dates stay empty. */
export function getDefaultNewsFilterState({
  programs = [],
  programFromUrl = null,
} = {}) {
  const allProgramIds = programs.map(item => item.id);
  const resolved = resolveCatalogProgramId(programFromUrl, programs);
  return {
    selectedProgram: resolved ? [resolved] : allProgramIds,
    selectedCategory: [],
    startDate: null,
    endDate: null,
  };
}

export function getFilteredNews(
  news,
  value,
  categories,
  programs,
  startDate,
  endDate,
  allProgramIds = [],
) {
  const searchQuery = (value || '').trim().toLowerCase();
  const programFilterActive = isEventProgramFilterActive(programs, allProgramIds);

  return (news || []).filter(item => {
    if(searchQuery && !(item.title || '').toLowerCase().includes(searchQuery)){
      return false;
    }
    if(programFilterActive){
      if(!relationMatchesSelection(programs, item.program)){
        return false;
      }
    }
    if(categories.length > 0){
      if(!relationMatchesSelection(categories, item.category)){
        return false;
      }
    }
    if(startDate){
      if(!moment(item.newsDate).isValid()) return false;
      if(moment(item.newsDate).isBefore(startDate)) return false;
    }
    if(endDate){
      if(!moment(item.newsDate).isValid()) return false;
      if(moment(item.newsDate).isAfter(endDate)) return false;
    }
    return true;
  });
}
